import React, { PureComponent } from 'react';
import { StripeProvider, Elements } from 'react-stripe-elements';
import { injectStripe } from 'react-stripe-elements';

const robotoFont = {
    family: 'Roboto',
    style: 'normal',
    weight: '400',
    src: "local('Roboto'), local('Roboto-Regular'), url(https://fonts.gstatic.com/s/roboto/v18/KFOmCnqEu92Fr1Mu4mxKKTU1Kg.woff2) format('woff2')",
    unicodeRange: 'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD'
}

export function withStripe() {
    return (WrappedComponent) => {
        const WrappedComponentContainer = injectStripe(WrappedComponent);

        class WrappedComponentWithStripe extends PureComponent {
            constructor(props) {
                super(props)

                this.state = {
                    stripe: null
                }
            }

            componentDidMount() {
                if (window.Stripe) {
                    this.setState({ stripe: window.Stripe(STRIPE_PUBLISHABLE_KEY) })
                } else {
                    document.querySelector('#stripe-js').addEventListener('load', () => {
                        this.setState({ stripe: window.Stripe(STRIPE_PUBLISHABLE_KEY) })
                    })
                }
            }

            render() {
                return (
                    <StripeProvider stripe={this.state.stripe}>
                        <Elements fonts={[robotoFont]}>
                            <WrappedComponentContainer {...this.props} />
                        </Elements>
                    </StripeProvider>
                )
            }
        }

        return WrappedComponentWithStripe
    }
}
